import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=000afa5e&shadow"
import script from "./Tab.vue?vue&type=script&lang=js&shadow"
export * from "./Tab.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports